import React from 'react';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { TileRuntimeContext } from '../../../../support/tileRuntimeContext';

interface RuntimeContextControlsProps {
  previewRuntimeContext: TileRuntimeContext;
  setContext: (update: Partial<TileRuntimeContext>) => void;
}

const RuntimeContextControls: React.FC<RuntimeContextControlsProps> = ({
                                                                         previewRuntimeContext,
                                                                         setContext,
                                                                       }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <TextField
        label="Email"
        value={previewRuntimeContext.email || ''}
        onChange={(e) =>
          setContext({
            email: e.target.value,
            userEmail: e.target.value,
            ownerEmail: e.target.value,
          })
        }
        sx={{ minWidth: 300 }}
      />

      <TextField
        label="Manager Email"
        value={previewRuntimeContext.managerEmail || ''}
        onChange={(e) =>
          setContext({
            managerEmail: e.target.value,
          })
        }
        sx={{ minWidth: 300 }}
      />

      <TextField
        label="Team Emails (comma-separated)"
        value={previewRuntimeContext.teamEmailsList || ''}
        onChange={(e) =>
          setContext({
            teamEmailsList: e.target.value,
            teamScope: e.target.value
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean),
          })
        }
        sx={{ minWidth: 400 }}
        multiline
        rows={2}
      />

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>View Mode</InputLabel>
        <Select
          value={previewRuntimeContext.viewMode || 'individual'}
          label="View Mode"
          onChange={(e) =>
            setContext({
              viewMode: e.target.value as 'individual' | 'team',
              isTeamView: e.target.value === 'team',
              isIndividualView: e.target.value === 'individual',
            })
          }
        >
          <MenuItem value="individual">Individual</MenuItem>
          <MenuItem value="team">Team</MenuItem>
        </Select>
      </FormControl>

      <Button
        variant="outlined"
        onClick={() =>
          setContext({
            email: 'test.user@example.com',
            userEmail: 'test.user@example.com',
            ownerEmail: 'test.user@example.com',
            managerEmail: 'test.manager@example.com',
            teamEmailsList: 'rep1@example.com, rep2@example.com, rep3@example.com',
            teamScope: ['rep1@example.com', 'rep2@example.com', 'rep3@example.com'],
            domain: 'salesforce' as const,
            viewMode: 'individual' as const,
            isTeamView: false,
            isIndividualView: true,
            teamSize: 1,
            perspective: 'individual_contributor' as const,
          })
        }
      >
        Load Sample Individual Context
      </Button>
    </Box>
  );
};

export default RuntimeContextControls;